import { 
    DashboardOutlined
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from './AppConfig'
  
  const dashBoardNavTree = [{
    key: 'home',
    path: `${APP_PREFIX_PATH}/home`,
    title: 'home',
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: []
  }]
  
  const navigationConfig = [
    ...dashBoardNavTree
  ]
  
  export default navigationConfig;
  